import {connect} from "react-redux";
import MFAEnabler from "./MultifactorEnabler"
import { sendEmailotp, updateMFAType, varifyEmailOTP } from "../../redux/actions/userManagement/mfa.action";
import { showAlertPopup } from "../../redux/actions/AlertErrorMessage/alertErrorMessage.action";


const mapStateToProps = null;

// const mapDispatchToProps = null
const mapDispatchToProps = (dispatch) => {
    return {
        sendEmailotp: (payload) => {
            return dispatch(sendEmailotp(payload))
        },
        varifyEmailOTP: (payload) => {
            return dispatch(varifyEmailOTP(payload))
        },
        showAlertPopup: (alertHeader,alertmessage) => {
            return dispatch(showAlertPopup(alertHeader,alertmessage))
          },
        // updateMFAType: (payload) => {
        //     return dispatch(updateMFAType(payload))
        // },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MFAEnabler);